import { IsNotEmpty, IsNumber, IsOptional } from "class-validator";

import { IIncentiveParamsMinNumberOfShowTypes } from "./incentive-params-number-of-show-types.interface";

export class IncentiveParamsMinNumberOfShowTypesDto
  implements IIncentiveParamsMinNumberOfShowTypes
{
  //
  @IsNotEmpty()
  @IsNumber()
  number_of_show_types: number;

  @IsNotEmpty()
  @IsNumber()
  fee: number;

  @IsOptional()
  @IsNumber()
  junior_fee?: number;
}
